import { useMemo, useRef, useState } from "react";
import Typhography from "../../shared/Typhography/Typhography";
import WarningIcon from "../../assets/icons/WarningIcon";
import CustomButton from "../../shared/CustomButton/CustomButton";
import "./useConfirmModal.scss";
import ReactDOM, { createPortal, render } from "react-dom";

import { v4 as uuid } from "uuid";
let resolveCallback: (value: unknown) => void;

interface UseConfirmModal {}

export const useConfirmModal = () => {
  const id = uuid();
  const idBackButton = uuid();
  const idConfirmButton = uuid();
  const [show, setShow] = useState(true);
  const callbackFunction = useRef<() => void>();
  const handleOpen = ({
    title,
    description,
    onConfirm,
    onConfirmError,
    onCancel,
  }: {
    title: string;
    description: string;
    onConfirm: () => void | Promise<any>;
    onCancel?: () => void;
    onConfirmError?: (error: unknown) => void;
  }) => {
    const nuovoDiv = document.createElement("div");
    // Assegna un ID o qualsiasi altra cosa desideri
    nuovoDiv.id = id;
    nuovoDiv.className = "custom-background-container-confirm-modal";
    nuovoDiv.innerHTML = `
    <div class="container-confirm-modal">
      <div class="container-header">
        <p class="text-bold-24">${title}</p>
        <svg class="icon-header" view-box="0 0 24 24">
        <path
        d="M22.2 17.6334L14.0016 3.39563C13.7967 3.04681 13.5042 2.75758 13.1532 2.55662C12.8021 2.35566 12.4046 2.24994 12 2.24994C11.5955 2.24994 11.198 2.35566 10.8469 2.55662C10.4958 2.75758 10.2033 3.04681 9.99847 3.39563L1.80003 17.6334C1.60291 17.9708 1.49902 18.3546 1.49902 18.7453C1.49902 19.1361 1.60291 19.5198 1.80003 19.8572C2.00228 20.2081 2.29425 20.4989 2.64599 20.6997C2.99773 20.9006 3.39658 21.0042 3.80159 21H20.1985C20.6032 21.0039 21.0016 20.9001 21.353 20.6993C21.7044 20.4985 21.9961 20.2078 22.1982 19.8572C22.3956 19.52 22.4998 19.1363 22.5001 18.7456C22.5004 18.3548 22.3969 17.971 22.2 17.6334ZM11.25 9.75C11.25 9.55109 11.329 9.36032 11.4697 9.21967C11.6104 9.07902 11.8011 9 12 9C12.1989 9 12.3897 9.07902 12.5304 9.21967C12.671 9.36032 12.75 9.55109 12.75 9.75V13.5C12.75 13.6989 12.671 13.8897 12.5304 14.0303C12.3897 14.171 12.1989 14.25 12 14.25C11.8011 14.25 11.6104 14.171 11.4697 14.0303C11.329 13.8897 11.25 13.6989 11.25 13.5V9.75ZM12 18C11.7775 18 11.56 17.934 11.375 17.8104C11.19 17.6868 11.0458 17.5111 10.9607 17.3055C10.8755 17.1 10.8532 16.8738 10.8966 16.6555C10.9401 16.4373 11.0472 16.2368 11.2045 16.0795C11.3619 15.9222 11.5623 15.815 11.7806 15.7716C11.9988 15.7282 12.225 15.7505 12.4305 15.8356C12.6361 15.9208 12.8118 16.065 12.9354 16.25C13.059 16.435 13.125 16.6525 13.125 16.875C13.125 17.1734 13.0065 17.4595 12.7955 17.6705C12.5845 17.8815 12.2984 18 12 18Z"
        fill="currentColor"
      />
        </svg>
      </div>
      <p class="confirm-modal-description text-regular-14">
      ${description}
</p>

<div class="container-modal-confirm-footer">

<button class="back-action bt-outline btn-custom" id="${idBackButton}">
Annulla
</button>
<button class="confirm-action bt-secondary btn-custom" id="${idConfirmButton}">
Conferma
</button>
</div>
      </div>
    `;

    const root = document.getElementById("root");
    root?.appendChild(nuovoDiv);

    const backButton = document.getElementById(idBackButton);
    const confirmButton = document.getElementById(idConfirmButton);
    if (backButton) {
      backButton.onclick = () => {
        onCancel?.();
        root?.removeChild(nuovoDiv);
      };
    }
    if (confirmButton) {
      confirmButton.onclick = async () => {
        confirmButton.style.opacity = "0.7";
        confirmButton.style.cursor = "not-allowed";
        confirmButton.style.pointerEvents = "none";

        confirmButton.innerHTML = `
        <div class="chakra-spinner spinner-confirm-action"></div>
        `;

        try {
          await onConfirm();
          // root?.removeChild(nuovoDiv);
        } catch (error) {
          onConfirmError?.(error);
        } finally {
          root?.removeChild(nuovoDiv);
        }
      };
    }
  };

  return {
    handleOpen,
  };
};
